import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h4 font-weight-medium header-container" }
const _hoisted_2 = { class: "header-container--left" }

import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
  title: String,
  showLeadingBtn: {
    type: Boolean,
    default: false
  },
  leadingIcon: {
    type: String,
    default: 'fa-solid fa-arrow-left'
  },
  showSecondaryTrailingBtn: {
    type: Boolean,
    default: false
  },
  secondaryTrailingIcon: {
    type: String,
    default: 'fa-solid fa-chevron-down'
  },
  showTrailingBtn: {
    type: Boolean,
    default: true
  },
  trailingIcon: {
    type: String,
    default: 'fa-solid fa-add'
  },
  showProgress: {
    type: Boolean,
    default: false
  }
},
  emits: ['on-click', 'on-leading-btn-click', 'on-secondary-btn-click'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (props.showLeadingBtn)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-leading-btn-click')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: props.leadingIcon,
                  size: "2x"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(props.title), 1)
      ]),
      _createElementVNode("div", null, [
        (props.showSecondaryTrailingBtn)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "mr-2",
              variant: "text",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('on-secondary-btn-click')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: props.secondaryTrailingIcon
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isSignedIn) && _unref(isAdmin) && props.showTrailingBtn && !props.showProgress)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              variant: "tonal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('on-click')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: props.trailingIcon
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          : (props.showProgress)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 2,
                indeterminate: "",
                color: "primary"
              }))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_v_divider, { class: "mt-2 mb-2" })
  ], 64))
}
}

})